$(function () {
    if (typeof hasSubmissionDates === 'undefined') {
        return;
    }
    $('#start-date, #end-date').datetimepicker({
        format: 'Y/m/d H:i',
        step: 5,
    });

    if (hasSubmissionDates) {
        $('#start-date').val(dates.start);
        $('#end-date').val(dates.end);
    } else {
        $('#start-date, #end-date').val(dayjs().format(DATE_TIME_PICKER_FORMAT));
    }
});
